module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isChrome) ? _c('p', {
    staticClass: "non-chrome-warning"
  }, [_vm._v("\n  Warning. This web-app is currently only tested against recent versions of Chrome. \n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f3bef5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NonChromeWarning.vue
// module id = 685
// module chunks = 2